import React from "react";
import { C1_TAG_RADIUS, C1_SYMBOL_TAG_HALF_HEIGHT } from "./C1_tagPlacement";

/** Keeps technical markers centered, with extra room for consumer symbols above their tags. */
export function C1_TagShape({ x, y, isButton, withSymbol = false, fill, stroke, strokeWidth }: {
  x: number;
  y: number;
  isButton: boolean;
  withSymbol?: boolean;
  fill: string;
  stroke: string;
  strokeWidth: number;
}) {
  const radius = C1_TAG_RADIUS;
  const fillInset = stroke === "none" ? 0 : strokeWidth / 2;
  const fillRadius = radius - fillInset;
  const common = {
    className: "C1_svgEloItemCircle",
    "data-c1-consumer-connection-anchor": "",
    "data-c1-button-connection-anchor": isButton ? "" : undefined,
    fill: "none", stroke, strokeWidth,
    pointerEvents: "all" as const,
  };
  // Separate the inset fill so the translucent border only blends with the plan beneath it.
  if (!isButton && !withSymbol) {
    return (
      <>
        <circle cx={x} cy={y} r={fillRadius} fill={fill} stroke="none" />
        <circle {...common} cx={x} cy={y} r={radius} />
      </>
    );
  }
  const halfHeight = isButton ? radius : C1_SYMBOL_TAG_HALF_HEIGHT;
  const fillHalfHeight = halfHeight - fillInset;
  const notchDepth = 2.3;
  const notchPath = [
    `M ${x} ${y - radius} v ${notchDepth}`,
    `M ${x} ${y + radius} v ${-notchDepth}`,
    `M ${x - radius} ${y} h ${notchDepth}`,
    `M ${x + radius} ${y} h ${-notchDepth}`,
  ].join(" ");
  return (
    <>
      <rect
        x={x - fillRadius}
        y={y - fillHalfHeight}
        width={fillRadius * 2}
        height={fillHalfHeight * 2}
        rx={isButton ? 0 : fillRadius}
        fill={fill}
        stroke="none"
      />
      <rect
        {...common}
        x={x - radius}
        y={y - halfHeight}
        width={radius * 2}
        height={halfHeight * 2}
        rx={isButton ? 0 : radius}
      />
      {isButton && <path
        d={notchPath}
        fill="none"
        stroke="#ffffff"
        strokeWidth={1.5}
        strokeLinecap="round"
        pointerEvents="none"
      />}
    </>
  );
}
